import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import {Box, Button} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontWeight: 'bold',
    fontSize: 22,
    backgroundColor: '#ffd600',
    padding: 10,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: 15,
      textAlign: 'left',
      '& .MuiButton-root': {
        marginTop: 5
      }
    }
  },
}));


export default function ResumeUploadNudge(props) {
  const classes = useStyles();
  return <Box className={classes.root} >
    Increase your hiring chances by uploading a résumé! <Button style={{marginLeft: 10}} variant='contained' color='primary' onClick={props.showMyAccount}>Add résumé now!</Button>
  </Box>;
}
